jQuery(document).ready(function($) {
    'use strict';

    const $breadcrumbs = document.querySelector('.woocommerce-breadcrumb ol');

    $(document.body).on('click', '.change', function(e) {
        $('html,body')
            .animate({scrollTop: $('.cart').offset().top - 115}, 'slow');
    });

    if ($breadcrumbs) {
        requestAnimationFrame(function() {
            $breadcrumbs.scrollLeft = $breadcrumbs.scrollWidth + 20;
        });
    }
});
